export function getItem(key) {
  if (!window.localStorage || !window.localStorage.setItem) return null
  return JSON.parse(window.localStorage.getItem(key))
}

export function setItem(key, object) {
  if (!window.localStorage || !window.localStorage.setItem) return
  window.localStorage.setItem(key, JSON.stringify(object))
}
